import { Link as RouterLink } from 'react-router-dom';

export default function Footer() {
  const categoryLinks = [
    { label: 'Shoes', href: 'https://kaspreadsheet.com/category-911-Shoes.html' },
    { label: 'Hoodies / Sweaters', href: 'https://kaspreadsheet.com/search-912/name/Shoes.html' },
    { label: 'T-Shirts', href: 'https://kaspreadsheet.com/search-913/name/Shoes.html' },
    { label: 'Jackets', href: 'https://kaspreadsheet.com/search-914/name/Shoes.html' },
    { label: 'Pants / Shorts', href: 'https://kaspreadsheet.com/search-915/name/Shoes.html' },
    { label: 'Headwear', href: 'https://kaspreadsheet.com/search-916/name/Shoes.html' },
    { label: 'Sets', href: 'https://kaspreadsheet.com/search-917/name/Shoes.html' },
  ];

  const moreCategories = [
    { label: 'Underwear / Underpants', href: 'https://kaspreadsheet.com/search-918/name/Shoes.html' },
    { label: 'Jersey', href: 'https://kaspreadsheet.com/search-919/name/Shoes.html' },
    { label: 'Accessories', href: 'https://kaspreadsheet.com/search-920/name/Shoes.html' },
    { label: 'Bags', href: 'https://kaspreadsheet.com/search-921/name/Shoes.html' },
    { label: 'Belts', href: 'https://kaspreadsheet.com/search-922/name/Shoes.html' },
    { label: 'Perfumes', href: 'https://kaspreadsheet.com/search-923/name/Shoes.html' },
    { label: 'Other Stuff', href: 'https://kaspreadsheet.com/search-924/name/Shoes.html' },
  ];

  const guideLinks = [
    { label: 'Complete Guide', path: '/superbuy-spreadsheet-complete-guide' },
    { label: 'Shoes Guide', path: '/superbuy-spreadsheet-shoes-guide' },
    { label: 'vs Alternatives', path: '/superbuy-spreadsheet-vs-alternatives' },
    { label: 'Beginner Tutorial', path: '/superbuy-spreadsheet-beginner-tutorial' },
    { label: 'Tips & Tricks', path: '/superbuy-spreadsheet-tips-tricks' },
    { label: 'Safety Guide', path: '/superbuy-spreadsheet-safety-guide' },
    { label: 'Product Discovery', path: '/superbuy-spreadsheet-product-discovery' },
    { label: 'Review 2026', path: '/superbuy-spreadsheet-review-2026' },
  ];

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">

          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-grid-fill text-background-50 text-base"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-foreground-900">
                Superbuy Spreadsheet
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              The most complete product finding and shopping resource platform. Discover organized product finds, shopping guides, and expert tips to shop smarter.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-primary-500 text-white text-sm font-semibold whitespace-nowrap hover:bg-primary-600 transition-all duration-200"
            >
              Visit Main Website
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">Shop Categories</h4>
            <ul className="space-y-2">
              {categoryLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">More Categories</h4>
            <ul className="space-y-2">
              {moreCategories.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">SEO Guides</h4>
            <ul className="space-y-2">
              {guideLinks.map((link) => (
                <li key={link.path}>
                  <RouterLink
                    to={link.path}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200"
                  >
                    {link.label}
                  </RouterLink>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} Superbuy Spreadsheet. All rights reserved.
          </p>
          <div className="flex items-center gap-1 flex-wrap justify-center">
            <RouterLink to="/" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors px-2">
              Home
            </RouterLink>
            <span className="text-foreground-300">·</span>
            <RouterLink to="/superbuy-spreadsheet-complete-guide" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors px-2">
              Complete Guide
            </RouterLink>
            <span className="text-foreground-300">·</span>
            <RouterLink to="/superbuy-spreadsheet-shoes-guide" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors px-2">
              Shoes Guide
            </RouterLink>
            <span className="text-foreground-300">·</span>
            <RouterLink to="/superbuy-spreadsheet-review-2026" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors px-2">
              Review
            </RouterLink>
            <span className="text-foreground-300">·</span>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-foreground-500 hover:text-primary-600 transition-colors px-2"
            >
              Main Website
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}